var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ViewportActionCreators } from '@printu/viewport';
import { editorSlice } from 'app/stores/editor';
import { HistoryActions } from 'app/stores/history/actions';
import { projectSlice } from 'app/stores/project';
import { getCurrentPage, getPageImage } from 'app/stores/selectors';
import { updateViewport } from 'app/stores/viewport/update';
import { fromUniform, toUniform } from 'app/utils/math';
import { clearTool } from './tools';
export const applyImageCrop = createAsyncThunk('editor/applyImageCrop', (_, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const state = getState();
    // const { viewport, image } = state;
    // const { design: designRect } = viewport;
    let unifiedCropArea = (_a = state.editor.controllerData) === null || _a === void 0 ? void 0 : _a.unifiedArea;
    if (!unifiedCropArea /* || image.type !== 'ready' */) {
        return;
    }
    const page = getCurrentPage(state);
    const image = getPageImage(state, page.id);
    const { crop: currentCrop } = page;
    const cropPageIsAbsolute = configGet('cropPageIsAbsolute', false);
    if (cropPageIsAbsolute === true) {
        // if crop was already applied - we need to crop in croppred area
        // i.e. crop out original crop rectanle and perform new crop on original image but relative to a cropped area
        if (currentCrop) {
            const imageBounds = Object.assign({ x: 0, y: 0 }, image.size);
            const correctUniformCrop = toUniform(fromUniform(fromUniform(imageBounds, currentCrop, true), unifiedCropArea, true), imageBounds);
            unifiedCropArea = correctUniformCrop;
        }
    }
    dispatch(projectSlice.actions.cropPage({ crop: unifiedCropArea }));
    updateViewport(undefined, dispatch, getState);
    dispatch(clearTool());
    dispatch(editorSlice.actions.setController({ controller: 'image-annotate' }));
}));
export const resetAppController = createAsyncThunk('editor/resetAppController', (_, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(editorSlice.actions.setController({ controller: 'image-annotate' }));
    dispatch(HistoryActions.unlock());
}));
export const showImageCropper = createAsyncThunk('editor/showImageCropper', (_, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const { viewport } = state;
    dispatch(HistoryActions.lock());
    dispatch(editorSlice.actions.setControllerData({
        key: 'viewport.mode',
        value: viewport.mode,
    }));
    dispatch(editorSlice.actions.setControllerData({
        key: 'viewport.zoom',
        value: viewport.zoom,
    }));
    // we have some issues with returning to edit mode
    dispatch(clearTool());
    dispatch(ViewportActionCreators.setMode('fit'));
    dispatch(editorSlice.actions.setController({
        controller: 'image-crop',
        data: { unifiedArea: undefined },
    }));
}));
export const showImageBackground = createAsyncThunk('editor/showBackgroundEditor', (_, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    // we have some issues with returning to edit mode
    dispatch(HistoryActions.record());
    dispatch(clearTool());
    dispatch(ViewportActionCreators.setMode('fit'));
    dispatch(editorSlice.actions.setController({
        controller: 'image-background',
        data: { unifiedArea: undefined },
    }));
}));
